import { getQueueLeadsGuessing } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useEffect, useState } from 'react';

const useQueueLeadsGuessingReport = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState(null);

	const handleSearch = async () => {
		setData(() => null);

		const response = await makeRequest(getQueueLeadsGuessing.bind());

		setData(() => response.data || []);
	};

	const isLoading = hasUnfilledRequest(getQueueLeadsGuessing);

	useEffect(() => {
		handleSearch();
	}, []);

	return {
		data,
		handleSearch,
		isLoading,
	};
};

export default useQueueLeadsGuessingReport;
